import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import MainLayout from "../components/feature/MainLayout";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import CategoryFilterPage from "../pages/category/filter/page";
import DetailPage from "../pages/detail/page";
import SearchPage from "../pages/search/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/:type", element: <CategoryPage /> },
      { path: "category/:type/filter", element: <CategoryFilterPage /> },
      { path: "detail/:id", element: <DetailPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;